import { render, staticRenderFns } from "./BreedDetail.vue?vue&type=template&id=42613864&scoped=true&"
import script from "./BreedDetail.vue?vue&type=script&lang=ts&"
export * from "./BreedDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BreedDetail.vue?vue&type=style&index=0&id=42613864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42613864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
